import { Paper, Text } from "@mantine/core";
import { SummaryCardProps } from "constants/types/report";
import { CSSProperties, FC } from "react";

const SummaryCard: FC<SummaryCardProps> = ({ label, value, color }) => {
  const accentStyle: CSSProperties = color
    ? { borderTop: `3px solid var(--mantine-color-${color}-6)` }
    : { borderTop: "3px solid transparent" };

  return (
    <Paper withBorder p="md" radius="md" style={accentStyle}>
      <Text size="xs" c="dimmed" fw={500} mb={6} style={{ letterSpacing: "0.03em" }}>
        {label}
      </Text>
      <Text fw={700} size="md" c={color} style={{ lineHeight: 1.2 }}>
        {value}
      </Text>
    </Paper>
  );
};

export default SummaryCard;
